var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "siteDetail" } },
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                height: "100vh",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
              },
            },
            [
              _c(
                "div",
                [
                  _c("md-progress-spinner", {
                    staticClass: "md-accent text-light",
                    attrs: { "md-diameter": 30, "md-mode": "indeterminate" },
                  }),
                ],
                1
              ),
            ]
          )
        : _c("div", [
            _c(
              "div",
              {
                staticClass: "header",
                staticStyle: { height: "75px", background: "#031529" },
              },
              [
                _c("span", [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.$t("message.siteAddress")) +
                        " :\n                    "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://" + _vm.site.siteAddress,
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(_vm.site.siteAddress))]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "btn btn primary",
                        attrs: { id: "turn-back" },
                        on: {
                          click: function ($event) {
                            return _vm.turnBackToTheSites()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("message.turnBack"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.createdDate")) +
                        " : " +
                        _vm._s(_vm.createdTime()) +
                        "\n                "
                    ),
                    _c(
                      "a-button",
                      {
                        staticClass: "bg-dark border-dark text-light",
                        on: {
                          click: function ($event) {
                            return _vm.edit(_vm.site._id)
                          },
                        },
                      },
                      [_c("ActionEdit")],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                {
                  staticClass: "left",
                  staticStyle: {
                    width: "15%",
                    background: "#1e1e2d !important",
                  },
                },
                [
                  _c(
                    "a-menu",
                    {
                      staticClass: "h-100 w-100",
                      attrs: {
                        "default-selected-keys": _vm.selectedPage,
                        mode: "vertical",
                        theme: "dark",
                      },
                      model: {
                        value: _vm.selectedPage,
                        callback: function ($$v) {
                          _vm.selectedPage = $$v
                        },
                        expression: "selectedPage",
                      },
                    },
                    [
                      _c(
                        "a-menu-item",
                        { key: "dashboard" },
                        [
                          _c("a-icon", { attrs: { type: "dashboard" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Dashboard")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "agents" },
                        [
                          _c("a-icon", { attrs: { type: "customer-service" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Agents")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "integration" },
                        [
                          _c("a-icon", {
                            attrs: { type: "safety-certificate" },
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Integration")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "settings" },
                        [
                          _c("a-icon", { attrs: { type: "setting" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Settings")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "contacts" },
                        [
                          _c("a-icon", { attrs: { type: "link" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Contacts")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "invoices" },
                        [
                          _c("a-icon", { attrs: { type: "gold" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.invoices")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "planManagment" },
                        [
                          _c("a-icon", { attrs: { type: "fire" } }),
                          _vm._v(
                            "\n                        Plan Yönetimi\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "welcomeSupsis" },
                        [
                          _c("a-icon", { attrs: { type: "form" } }),
                          _vm._v(
                            "\n                        Welcome Supsis\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "demoForm" },
                        [
                          _c("a-icon", { attrs: { type: "form" } }),
                          _vm._v(
                            "\n                        Demo Formu\n                    "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right", staticStyle: { width: "85%" } },
                [
                  _c(
                    "a-card",
                    {
                      style: [
                        _vm.selectedPage.includes("planManagment") && {
                          background: "rgb(248, 249, 250)",
                        },
                      ],
                    },
                    [
                      _vm.selectedPage.includes("dashboard")
                        ? _c("div", [
                            _c("div", { staticClass: "box-container" }, [
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.Agents"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.site.agentCount) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.Domain"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.site.integratedOrigins.length)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.lastActivity"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.lastActivity())),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.Integration"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _vm.site.isIntegrated
                                      ? _c("a-icon", {
                                          staticStyle: { color: "green" },
                                          attrs: { type: "check-circle" },
                                        })
                                      : _c("a-icon", {
                                          staticStyle: { color: "red" },
                                          attrs: { type: "close-circle" },
                                        }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("billing.realtimeVisitorCount")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.site.realtimeVisitorCount)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.suspend"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "md-switch",
                                      {
                                        staticClass: "md-primary",
                                        model: {
                                          value: _vm.suspend,
                                          callback: function ($$v) {
                                            _vm.suspend = $$v
                                          },
                                          expression: "suspend",
                                        },
                                      },
                                      [
                                        _vm.site.suspend
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.active"))
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.passive")
                                                )
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.partner"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.$_.get(_vm.site, "partner.name"))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(_vm.$t("billing.trialDay"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.trialDay) +
                                        " - " +
                                        _vm._s(_vm.$t("billing.trialDay"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(_vm.getRemainingTrialDay()) +
                                        " - " +
                                        _vm._s(_vm.$t("billing.daysLeft"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: { click: _vm.showTrialPrompt },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("Billing Wizard"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "md-switch",
                                      {
                                        staticClass: "md-primary",
                                        model: {
                                          value: _vm.planWizardCompleted,
                                          callback: function ($$v) {
                                            _vm.planWizardCompleted = $$v
                                          },
                                          expression: "planWizardCompleted",
                                        },
                                      },
                                      [
                                        _vm.site.settings.planWizardCompleted
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.active"))
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.passive")
                                                )
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("Payment Method"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        model: {
                                          value: _vm.paymentMethod,
                                          callback: function ($$v) {
                                            _vm.paymentMethod = $$v
                                          },
                                          expression: "paymentMethod",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "btc" } },
                                          [_vm._v("BTC")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "eft" } },
                                          [_vm._v("EFT/HAVALE")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "credit-card" } },
                                          [_vm._v("KREDI KARTI")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("GENEL INDIRIM"),
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.totalDiscount) + "%"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: {
                                        click: _vm.showTotalDiscountPrompt,
                                      },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("Whatsapp Bakiye"),
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.whatsappWallet) + "TL"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: {
                                        click: _vm.showWhasappWalletPrompt,
                                      },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("Whatsapp Alt Limit"),
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.maxLowBalance) + "TL"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: {
                                        click: _vm.showWhasappLowLimitPrompt,
                                      },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("Whatsapp Gupshup Commission"),
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.gupshupCommission) + "%"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: {
                                        click: _vm.showGupshupCommissionPrompt,
                                      },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("Email Gönderim Limiti"),
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.monthlyMailSendLimit)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: {
                                        click:
                                          _vm.showMonthlyMailSendLimitPrompt,
                                      },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("Whatsapp Commission"),
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.whatsappCommission) + "%"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: {
                                        click: _vm.showWhatsappCommissionPrompt,
                                      },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("Whatsapp Mesaj Fiyatı"),
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.whatsappPerMessagePrice) + "TL"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { shape: "circle" },
                                      on: {
                                        click: _vm.showWhatsappPerMessagePrompt,
                                      },
                                    },
                                    [_c("a-icon", { attrs: { type: "edit" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.mobile"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _vm.site.mobileUserCount > 0
                                      ? _c("a-icon", {
                                          staticStyle: { color: "green" },
                                          attrs: { type: "check-circle" },
                                        })
                                      : _c("a-icon", {
                                          staticStyle: { color: "red" },
                                          attrs: { type: "close-circle" },
                                        }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.webSite"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "text-decoration": "underline",
                                      },
                                      attrs: {
                                        href:
                                          (_vm.IS_DEV_ENVIRONMENT
                                            ? "http"
                                            : "https") +
                                          "://" +
                                          _vm.site.settings.website,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("a-icon", { attrs: { type: "link" } }),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.site.settings.website)
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.websiteOrigins"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "value" },
                                  _vm._l(
                                    _vm.site.integratedOrigins,
                                    function (dom) {
                                      return _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "200px",
                                            padding: "3px",
                                          },
                                          attrs: { value: dom },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                "text-decoration": "underline",
                                              },
                                              attrs: {
                                                href:
                                                  (_vm.IS_DEV_ENVIRONMENT
                                                    ? "http"
                                                    : "https") +
                                                  "://" +
                                                  dom,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c("a-icon", {
                                                attrs: { type: "link" },
                                              }),
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(dom) +
                                                  "\n                                        "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                staticStyle: { "justify-content": "center" },
                              },
                              [
                                _c(
                                  "a-button",
                                  {
                                    staticClass:
                                      "bg-danger border-dark text-light",
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(_vm.site)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mr-1",
                                        staticStyle: {
                                          "font-size": "1.5rem",
                                          "font-weight": "bold",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("message.deleteThisSite")
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("agents")
                        ? _c(
                            "div",
                            [
                              _c("UserList", {
                                attrs: { "site-id": _vm.site._id },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("integration")
                        ? _c("div", [
                            _vm._v(_vm._s(_vm.$t("message.integration"))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("settings")
                        ? _c("div", [_vm._v(_vm._s(_vm.$t("message.setting")))])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("invoices")
                        ? _c(
                            "div",
                            [
                              _c("InvoiceList", {
                                attrs: {
                                  "initial-data": _vm.site,
                                  "site-address": _vm.site.clientAddress,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("contacts")
                        ? _c("div", [
                            _c("div", { staticClass: "box-container" }, [
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.ownerName"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.site.rootUserName) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.ownerEmailAddress"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.site.rootUserEmail) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("planManagment")
                        ? _c("div", { staticClass: "plans-page" }, [
                            _vm.showingBillingPlans
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "material-icons go-back-button",
                                        on: { click: _vm.goBack },
                                      },
                                      [_vm._v("arrow_back")]
                                    ),
                                    _vm._v(" "),
                                    _c("CustomerPlans", {
                                      attrs: {
                                        "is-admin": true,
                                        "site-id": _vm.site._id,
                                        "site-appsumo-coupons":
                                          _vm.site.appsumoCoupons,
                                        "site-current-plans": _vm.currentPlans,
                                        "site-plans": _vm.plans,
                                        type: _vm.showingBillingPlans,
                                      },
                                      on: { "go-back": _vm.goBack },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "a-modal",
                                      {
                                        attrs: {
                                          visible: _vm.deleteItem,
                                          icon: "exclamation-circle",
                                          title: "Delete Package",
                                        },
                                        on: {
                                          cancel: function ($event) {
                                            _vm.deleteItem = null
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "footer",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "a-button",
                                                    {
                                                      key: "back",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.deleteItem = null
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chatbotv2.dismiss"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-button",
                                                    {
                                                      key: "submit",
                                                      attrs: { type: "danger" },
                                                      on: {
                                                        click:
                                                          _vm.deletePackage,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chatbotv2.delete"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2180623913
                                        ),
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "Bu paketi silmek istediğinizden eminmisiniz kalıcı olarak silinecektir."
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.modalShowing
                                      ? _c("CreateNewPlanModal", {
                                          on: {
                                            cancel: function ($event) {
                                              _vm.modalShowing = false
                                            },
                                            create: _vm.createNewPlan,
                                            update: _vm.planUpdate,
                                          },
                                          model: {
                                            value: _vm.form,
                                            callback: function ($$v) {
                                              _vm.form = $$v
                                            },
                                            expression: "form",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "header-top" }, [
                                      _c("div", { staticClass: "title" }, [
                                        _vm._v("Mevcut Planlar"),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("CurrentPlans", {
                                      class: "current-plans",
                                      attrs: {
                                        "site-id": _vm.site._id,
                                        "site-current-plans": _vm.currentPlans,
                                        "site-plans": _vm.plans,
                                      },
                                      on: { show: _vm.showPlans },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "header-plans-top" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "create-plan",
                                            on: {
                                              click: function ($event) {
                                                _vm.modalShowing = true
                                              },
                                            },
                                          },
                                          [_vm._v("Plan Oluştur")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      Object.keys(_vm.groupedPlans),
                                      function (planName) {
                                        return _c(
                                          "div",
                                          { staticClass: "plan-container" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "plan-title" },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      planName
                                                        .split("-")
                                                        .map(function (c) {
                                                          return (
                                                            c[0].toUpperCase() +
                                                            c
                                                              .slice(1)
                                                              .toLowerCase()
                                                          )
                                                        })
                                                        .join(" ")
                                                    ) +
                                                    "\n                                    Paketleri\n                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "plan-items-wrapper",
                                              },
                                              [
                                                _c(
                                                  "transition",
                                                  { attrs: { name: "scale" } },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.groupedPlans[
                                                                planName
                                                              ].length > 4,
                                                            expression:
                                                              "groupedPlans[planName].length > 4",
                                                          },
                                                        ],
                                                        attrs: {
                                                          id: "prev-button",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "md-icon",
                                                          {
                                                            staticClass:
                                                              "navigate-arrow navigate-left",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "arrow_back_ios_new\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "plan-items" },
                                                  _vm._l(
                                                    _vm.groupedPlans[planName],
                                                    function (item) {
                                                      return _c("Card", {
                                                        key: item._id,
                                                        staticClass: "plan",
                                                        attrs: {
                                                          plan: item,
                                                          "editable-card": true,
                                                          "self-site": true,
                                                          visibilityDetails:
                                                            _vm.site
                                                              .visibilityPlanSettings,
                                                        },
                                                        on: {
                                                          "edit-action":
                                                            function ($event) {
                                                              return _vm.editPlan(
                                                                item
                                                              )
                                                            },
                                                          "delete-action":
                                                            function ($event) {
                                                              _vm.deleteItem =
                                                                item
                                                            },
                                                          visibilityChanged:
                                                            _vm.visibilityChange,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "transition",
                                                  { attrs: { name: "scale" } },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.groupedPlans[
                                                                planName
                                                              ].length > 4,
                                                            expression:
                                                              "groupedPlans[planName].length > 4",
                                                          },
                                                        ],
                                                        attrs: {
                                                          id: "next-button",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "md-icon",
                                                          {
                                                            staticClass:
                                                              "navigate-arrow navigate-right",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "arrow_forward_ios\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("demoForm")
                        ? _c(
                            "div",
                            [
                              _c("DemoFormViews", {
                                attrs: {
                                  "site-id": _vm.site._id,
                                  "site-data": _vm.site,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("welcomeSupsis")
                        ? _c(
                            "div",
                            [
                              _c("WelcomeSupsisViews", {
                                attrs: {
                                  "site-id": _vm.site._id,
                                  "site-data": _vm.site,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
      _vm._v(" "),
      _c("SiteCreateModalForm", {
        attrs: {
          "edit-mode": true,
          "on-cancel": _vm.onModalFormCancel,
          "on-success": _vm.onModalFormSuccess,
          "updating-site": _vm.updatingSite,
          visible: _vm.modalVisible,
          "is-modal-show": _vm.isNewModal,
          "close-modal": _vm.hideNewModalForm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }